import { cn } from "@/lib/cn";

interface FormFieldProps {
  /** The label text displayed above the input. */
  label: string;
  /** The input's id, used to bind the label via htmlFor. */
  htmlFor: string;
  /** Optional error message displayed below the input. */
  error?: string;
  /** Optional content rendered inline with the label (e.g. "Forgot password?" link). */
  labelAction?: React.ReactNode;
  /** The input element(s). */
  children: React.ReactNode;
  className?: string;
}

export function FormField({
  label,
  htmlFor,
  error,
  labelAction,
  children,
  className,
}: FormFieldProps) {
  return (
    <div className={cn("space-y-appkit-xs", className)}>
      <div className="flex items-center justify-between">
        <label
          htmlFor={htmlFor}
          className="block text-appkit-body font-medium text-secondary"
        >
          {label}
        </label>
        {labelAction}
      </div>
      {children}
      {error && (
        <p className="text-appkit-body text-danger" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
